<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Clientes</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <div class="form-field">
            <input-field id="cupo_maximo" v-model="cupoMaximo" placeholder="$ #,###.##" vMoney :format="money">
              Cupo máximo global
            </input-field>
          </div>
          <button v-show="cupoMaximo != ''" type="button" @click="actualizarCupos" class="btn-primary">
            <i class="fa fa-refresh"></i><span>Actualizar cupos globales</span>
          </button>
          <button v-if="puedeCrear" type="button" @click="crear" class="btn-primary">
            <i class="fa fa-plus"></i><span>Nuevo</span>
          </button>
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="exportarExcel" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card mb-2">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-inline">
              <strong>Estados:</strong>
              <label for="activosParam">
                <input
                  id="activosParam"
                  v-model="form.estadoP"
                  type="radio"
                  value="A"
                />
                <span>Activos</span>
              </label>
              <label for="inactivosParam">
                <input
                  id="inactivosParam"
                  v-model="form.estadoP"
                  type="radio"
                  value="I"
                />
                <span>Inactivos</span>
              </label>
              <label for="todosParam">
                <input
                  id="todosParam"
                  v-model="form.estadoP"
                  type="radio"
                  value="T"
                />
                <span>Todos</span>
              </label>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-inline">
              <strong>Cobro:</strong>
              <label for="incobrablesCobroParam">
                <input
                  id="incobrablesCobroParam"
                  v-model="form.tipoEstadoP"
                  type="radio"
                  value="I"
                />
                <span>Incobrables</span>
              </label>
              <label for="activosCobroParam">
                <input
                  id="activosCobroParam"
                  v-model="form.tipoEstadoP"
                  type="radio"
                  value="A"
                />
                <span>Activos</span>
              </label>
              <label for="todosCobroParam">
                <input
                  id="todosCobroParam"
                  v-model="form.tipoEstadoP"
                  type="radio"
                  value="T"
                />
                <span>Todos</span>
              </label>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                v-model="form.searchP"
                id="buscar"
                placeholder="Realice una consulta..."
              >
                Consultar:
              </input-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <k-table
          @editar="editar"
          @eliminar="eliminar"
          :createButton="false"
          :editButton="puedeEditar"
          :deleteButton="puedeAnular"
          :path="path"
          :params="form"
          :buscarButton="false"
          ref="listaClientes"
          :columns="[
            {
              display: 'Identificación',
              value: 'numero_identificacion',
            },
            {
              display: 'Apellidos',
              value: 'apellidos_completos',
            },
            {
              display: 'Nombres',
              value: 'nombres_completos',
            },
            {
              display: 'Estado cobro',
              value: 'descripcion_tipo_estado',
            },
            {
              display: 'Teléfonos',
              value: 'telefonos',
            },
            {
              display: 'Celulares',
              value: 'celulares',
            },
            {
              display: 'Dirección',
              value: 'direccion',
            },
            {
              display: 'Cupo máximo',
              value: 'cupo_maximo',
            },
            {
              display: 'Creador',
              value: 'creador.nombre',
            },
            {
              display: 'Creación',
              value: 'created_at',
            },
            {
              display: 'Modificador',
              value: 'modificador.nombre',
            },
            {
              display: 'Modificación',
              value: 'updated_at',
            }
          ]"
        ></k-table>
      </div>
    </div>
    <modal
      name="cliente"
      scrollable
      reset
      adaptive
      resizable
      height="auto"
      width="65%"
      :clickToClose="false"
    >
      <cliente
        :puedeCrear="puedeCrear"
        @fotosGuardadas="$modal.hide('cliente'); consultar();"
        @guardar="$modal.hide('cliente'); consultar();"
        @cerrar="$modal.hide('cliente')"
        :clienteId="clienteId"
        :puedeVerClaveAccesoWeb="puedeVerClaveAccesoWeb"
      ></cliente>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    puedeConsultar: {
      type: Boolean,
      required: true
    },
    puedeEditar: {
      type: Boolean,
      required: true
    },
    puedeCrear: {
      type: Boolean,
      required: true
    },
    puedeAnular: {
      type: Boolean,
      required: true
    },
    puedeVerClaveAccesoWeb: {
      type: Boolean,
      required: true
    },
  },
  data: function() {
    return {
      clienteId: '',
      path: `${url}/clientes/consultar/C`,
      form: {
        tipoEstadoP: 'T',
        searchP: '',
        estadoP: 'T',
      },
      cupoMaximo: '',
      money: money
    }
  },
  methods: {
    crear: function () {
      this.clienteId = '';
      this.$modal.show('cliente');
    },
    actualizarCupos: function () {
      swal({
        title: "¿Desea actualizar el cupo de todos los clientes?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          axios.post(url + '/clientes/actualizar-cupo', {
            cupo_maximo: this.cupoMaximo
          }).then(() => {
            swal('El cupo fue actualizado exitósamente.', 'Realizado', 'success');
            this.consultar();
          }).catch(() => {
            swal('Hubo un error, intente nuevamente.', 'Error', 'error');
          });
        }
      });
    },
    editar: function(row){
      this.clienteId = row.id;
      this.$modal.show('cliente');
    },
    eliminar: async function(row){
      let result = null;
      if (row.estado === "A") {
        result = await swal.fire({
          title: "¿Deseas inactivar el cliente?",
          text: "Debe ingresar una observación",
          icon: "question",
          input: "textarea",
          inputPlaceholder: "Escriba una observación...",
          inputAttributes: {
            maxlength: 500,
          },
          inputValidator: (value) => {
            if (!value || !value.trim()) {
              return "Debe ingresar una observación.";
            }
            return null;
          },
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "No",
        });
      } else {
        result = await swal.fire({
          title: "¿Deseas re-activar el cliente?",
          text: "Se requiere confirmación",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "No",
        });
      }
      if (!result.value) {
        return;
      }
      axios
        .delete(url + "/clientes/" + row.id, {
          data: {
            observacion: row.estado === "A" ? result.value.trim() : null,
          }
        })
        .then(({data}) => {
          const {error, msg} = data;
          if(error) {
            swal("Advertencia", msg, "warning");
          } else {
            swal(
              "El cliente ha sido " +
              (row.estado === "A" ? "inactivado" : "re-activado") + ".",
              "Realizado",
              "success"
            );
            this.consultar();
          }
        })
        .catch(({ response }) => {
          if (response && response.status === 422 && response.data.errors && response.data.errors.observacion) {
            swal("Advertencia", response.data.errors.observacion[0], "warning");
            return;
          }
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    consultar: function() {
      this.$refs.listaClientes.loadRows();
    },
    exportarExcel: function() {
      let urlApi = `${url}/clientes/consultar/E${this.serialize(this.form)}`;
      window.open(urlApi, '_blank');
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
  },
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/clientes/ListaClientes.vue